"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var ProductGrid = /*#__PURE__*/function () {
  function ProductGrid(component) {
    (0, _classCallCheck2["default"])(this, ProductGrid);
    this.dom = {
      $component: component
    }, this.state = {};
    this.mount();
  }

  (0, _createClass2["default"])(ProductGrid, [{
    key: "mount",
    value: function mount() {
      console.log('ProductGrid : mount', this);
    }
  }, {
    key: "unmount",
    value: function unmount() {
      console.log('ProductGrid : unmount', this);
    }
  }]);
  return ProductGrid;
}();

exports["default"] = ProductGrid;